import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { People as PeopleIcon } from '@mui/icons-material';

import { MenuItem } from 'types/global';

type UsersProps = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function Users({ selected, onSelect, open }: UsersProps) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/panel/users"
			selected={selected === MenuItem.PanelUsers}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.PanelUsers)}
		>
			<ListItemIcon>
				<PeopleIcon />
			</ListItemIcon>
			{open && <ListItemText primary={t('common:panel_user_plural')} />}
		</ListItem>
	);
}
